var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.12 2.50891L2 0.628906L10 8.62891L2 16.6289L0.12 14.7489L6.22667 8.62891L0.12 2.50891Z",
    fill: "#969FA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDisabled);
export default __webpack_public_path__ + "static/media/arrow-right-disabled.bb9f0da35d1aa6eafded54283de42a4c.svg";
export { ForwardRef as ReactComponent };